import { CustomHeader } from '../../../../../common'

export const HeaderSection = ({ useFetchInit }) => {

    const { Forms } = useFetchInit
    const { FormScreen } = Forms
    const { formState } = FormScreen

    const customFields = [
        { 
            label: 'Título',
            value: formState?.titulo || ''
        },
        {
            label: 'Descripcion',
            value: formState?.descripcion || '',
            md: 12
        }
    ]

    return (
        <CustomHeader
            backLabel="Volver a operaciones"
            // onBack={handleClickReturnToOperation}
            customFields={customFields}
        />
    )
}
